<template>
    <v-layout class="app-main-custom" :full-height="true">
        <v-main class="app-main-custom">
            <v-container :fluid="true" class="app-container-custom">
                <router-view></router-view>
            </v-container>
        </v-main>
    </v-layout>
</template>

<script>
export default {
    name: 'AuthLayout',
}
</script>
